import { errorHandler, getErrorDialogFromError } from "./errorToMessage"

export default {
	ErrorHandler: errorHandler,
	getErrorDialogFromError
}